import React from "react";
import {
  message,
  Button,
  Space,
  Row,
  Col,
  Modal,
  Image,
  Tooltip,
  Drawer,
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import { Link } from "react-router-dom";
import Excel from "../assets/images/NewDesign/Excel.svg";
import editIcon from "../assets/images/NewDesign/pencil-square.svg";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";
import { CloseOutlined } from "@ant-design/icons";
import withRouter from "../withRouter";
import ListTable from "./ListTable";
import FuelDetailsStore from "../store/FuelDetailsStore";
import FuelDetailsAdd from "./FuelDetailsAdd";
import CompanyAutocomplete from "./CompanyAutocomplete";
import CompanyStore from "../store/CompanyStore";
import downloadIcon from "../assets/images/NewDesign/Download.svg";

class FuelDetailsList extends React.Component {
  constructor(props, context) {
    super(props);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.companyStore = new CompanyStore(this);
    this.fuelDetailsStore = new FuelDetailsStore(this);

    this.state = {
      loading: false,
      pageSize: 50,
      currentPage: 1,
      company_name: "",
      listUpdated: 0,
      company_value_label: "",
      openFuelForm: false,
      fuelId: "",
      listDataUpdate: false,
      openDeleteModal: false,
      deleteData: {},
    };
    //columns
    this.columns = [
      {
        title: context.translate("_COMPANY_NAME_"),
        dataIndex: "company",
        width: 35,
        ellipsis: {
          showTitle: true,
        },
        render: (value, record) => {
          return (
            <Tooltip placement="topLeft" title={value}>
              <Link
                style={{ color: "#2563EB", textDecoration: "none" }}
                onClick={(e) => {
                  e.preventDefault();
                  this.props.canUpdate("fueldetailslist") &&
                    this.onEdit(record);
                }}
              >
                {value}
              </Link>
            </Tooltip>
          );
        },
      },
      {
        title: context.translate("_FLEET_VEHICLEDETAIL_FUELTYPEDDL_PETROL"),
        dataIndex: "petrol",
        width: 30,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        title: context.translate("_FLEET_VEHICLEDETAIL_FUELTYPE_DIESEL_"),
        dataIndex: "Diesel",
        width: 30,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        title: context.translate("_ACTION_"),
        dataIndex: "groupname",
        width: 5,
        align: "center",
        ellipsis: {
          showTitle: true,
        },
        render: (_, record) => {
          return (
            <Space>
              {this.props.canUpdate("fueldetailslist") && (
                <Tooltip
                  title={this.context.translate("_EDIT_RECORD_")}
                  placement="bottom"
                >
                  <Image
                    style={{
                      height: "19px",
                      width: "14px",
                      borderRadius: "0px",
                      cursor: "pointer",
                    }}
                    src={editIcon}
                    onClick={async (e) => {
                      e.preventDefault();
                      await this.onEdit(record);
                    }}
                  ></Image>
                </Tooltip>
              )}

              {this.props.canDelete("fueldetailslist") && (
                <Tooltip
                  title={this.context.translate("_DELETE_RECORD_")}
                  placement="bottom"
                >
                  <Image
                    src={require("../assets/images/NewDesign/Delete.png")}
                    style={{ width: "14px", cursor: "pointer" }}
                    onClick={() =>
                      this.setState({
                        openDeleteModal: true,
                        deleteData: record,
                      })
                    }
                  ></Image>
                </Tooltip>
              )}
            </Space>
          );
        },
      },
    ];
    this.ExportMenuProps = {
      items: [
        {
          label: context.translate("_EXPORT_AS_EXCEL_"),
          key: "excel",
          icon: (
            <Image
              style={{ height: "16px", width: "16px" }}
              src={Excel}
            ></Image>
          ),
        },
      ],
      onClick: (val) => {
        if (this.fuelDetailsStore?.fuelDetail?.length === 0) return;
        const result = [];
        this.columns.map((obj) => result.push(obj.dataIndex));

        var getData = {
          cid: this.state.companyId,
          colList: result,
        };

        if (val.key === "excel") {
          this.fuelDetailsStore.exportExcel(getData);
        }
      },
    };
  }

  refreshList = async () => {
    if (this.state.companyId) {
      this.setState({ loading: true });
      await this.fuelDetailsStore.loadData({
        offset: 0,
        limit: 50,
        companyId: this.state.companyId,
      });
      this.setState({ loading: false, currentPage: 1 });
    }
  };
  onEdit = async (record) => {
    console.log(record.roleId, "dd");
    await this.context.viewStateStore.setFuelDetailsStates({
      companyId: record.companyId,
    });
    await this.setState({ fuelId: record.fuelId });
    await this.setState({ openFuelForm: true });
    console.log(record.fuelId);
  };
  async onDelete(record) {
    const response = await this.fuelDetailsStore.deleteRecord({
      fuelId: record.fuelId,
    });
    if (response?.data?.success === "S") {
      message.success(response.data.message);
      this.setState({ openDeleteModal: false });
      this.handleSearch();
    } else {
      message.error(response.data.message);
    }
  }

  async componentDidMount() {
    if (
      Number(this.props.getUserData().isadmin) !== -1 &&
      Number(this.props.getUserData().isadmin) !== 3
    ) {
      console.log(this.props.getUserData().userCompanyId);
      await this.setState({
        companyId: this.props.getUserData().userCompanyId,
      });
      //  console.log(this.state.companyId)
      await this.setState({ userId: this.props.getUserData().userId });
      await this.handleSearch();
    }
    this.setState({ pageSize: 50 });
  }

  async handleTableChange(pagination, filters, sorter) {
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });
    this.handleSearch();
  }

  async handleChange(comp) {
    await this.setState({ currentPage: 1, companyId: comp.value });
    const singleData = await this.companyStore.getCompanyDataById(comp.value);
    await this.setState({ company_value_label: singleData });

    await this.handleSearch();
  }

  async handleSearch() {
    this.setState({ loading: true });
    await this.fuelDetailsStore.loadData({
      offset: (this.state.currentPage - 1) * this.state.pageSize,
      limit: this.state.pageSize,
      companyId: this.state.companyId,
    });
    await this.setState({ listUpdated: 1 }); //need to reload data
  }

  responseMsg = async (response) => {
    console.log(response);
    if (response?.success === "S") {
      message.success("Fuel Details Saved");
      await this.setState({ listDataUpdate: true });
      await this.setState({ openFuelForm: false });

      //  await this.handleSearch();
      //   this.props.navigate("/fueldetailslist/" + this.state.companyId);
      // this.props.navigate("/fueldetailslist");
    } else {
      message.error(response.message);
    }
  };

  async componentDidUpdate(prevProps, prevState) {
    if (
      this.state.openFuelForm &&
      prevState.openFuelForm !== this.state.openFuelForm
    ) {
      setTimeout(() => {
        window.dispatchEvent(new Event("resize"));
      }, 10);
    }

    if (prevState.listDataUpdate !== this.state.listDataUpdate) {
      const beforeEditCompanyId =
        this.context.viewStateStore.fuelDetailsObject.companyId;

      if (beforeEditCompanyId !== "") {
        await this.fuelDetailsStore.loadData({
          offset: (this.state.currentPage - 1) * this.state.pageSize,
          limit: this.state.pageSize,
          companyId: beforeEditCompanyId,
        });
        const singleData = await this.companyStore.getCompanyDataById(
          this.context.viewStateStore.fuelDetailsObject.companyId
        );
        await this.setState({ listUpdated: 1 }); //need to reload data
        await this.setState({ company_value_label: singleData });
      }
      await this.setState({ listDataUpdate: false });
    }
  }

  closeModal = () => {
    this.setState({ openFuelForm: false, userId: "" });
  };
  render() {
    return (
      <>
        <div className="listHeader">
          <Row className="listInputRow">
            <Col span={16}>
              <Space>
                <CompanyAutocomplete
                  className="searchInput"
                  onChange={(value) => this.handleChange(value)}
                  value={
                    this.state.company_value_label
                      ? this.state.company_value_label
                      : null
                  }
                  // allowClear={true}
                  style={{ width: 200 }}
                />
              </Space>
            </Col>
            <Col span={8}>
              <Space
                style={{
                  float:
                    this.context.locale.direction === "ltr" ? "right" : "left",
                }}
              >
                <Tooltip
                  title={this.context.translate("_REFRESH_")}
                  placement="bottom"
                >
                  <Image
                    style={{
                      height: 18,
                      marginInlineEnd: "20px",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                    src={refreshIcon}
                    onClick={() => this.refreshList()}
                  ></Image>
                </Tooltip>

                <Button
                  className="downloadExcelButton"
                  disabled={
                    this.fuelDetailsStore?.fuelDetail?.length > 0 ? false : true
                  }
                  onClick={(val) => {
                    let result = [];
                    if (true) {
                      this.columns.map((obj) => result.push(obj.dataIndex));

                      var getData = {
                        cid: this.state.companyId,
                        searchField: "",
                        colList: result,
                      };

                      if (val) {
                        this.fuelDetailsStore.exportExcel(getData);
                      }
                    }
                  }}
                >
                  <Tooltip
                    title={this.context.translate("_DOWNLOAD_")}
                    placement="bottom"
                  >
                    <Image
                      style={{
                        height: 18,
                        width: "auto",
                      }}
                      src={downloadIcon}
                    />
                  </Tooltip>
                </Button>

                {this.props.canCreate("fueldetailslist") && (
                  <Button
                    className="addButtonClass"
                    onClick={() =>
                      this.setState({ openFuelForm: true, fuelId: "" })
                    }
                  >
                    <Image
                      style={{ marginInlineEnd: "5px", width: 13 }}
                      src={require("../assets/images/NewDesign/plus (Stroke).png")}
                    ></Image>
                    {this.context.translate("_FLEET_DRIVER_DRIVERLIST_ADDBTN_")}
                  </Button>
                )}
              </Space>
            </Col>
          </Row>

          <ListTable
            current={this.state.currentPage}
            pageSize={this.state.pageSize}
            total={this.fuelDetailsStore?.total}
            columns={this.columns}
            dataSource={this.fuelDetailsStore?.fuelDetail}
            loading={this.fuelDetailsStore?.loading}
            onChange={this.handleTableChange}
          />

          {this.state.openFuelForm && (
            // <Modal
            //   bodyStyle={{ height: "637px" }}
            //   className="formShowModal" //  {/* css class */}
            //   // title="Fuel Details"
            //   title={this.context.translate("_FUEL_DETAIL_")}
            //   centered
            //   visible={this.state.openFuelForm}
            //   footer={null}
            //   onCancel={() => {
            //     this.setState({ openFuelForm: false, userId: "" });
            //   }}
            //   width={665}
            // >
            <Drawer
              className="uploadExcelDrawer"
              width={716}
              closeIcon={false}
              open={this.state.openFuelForm}
              placement={
                this.context.locale.language === "arabic" ? "left" : "right"
              }
              footer={false}
              title={
                <div className="formTitle">
                  {this.context.translate("_FUEL_DETAIL_")}
                  <p className="formDescription">
                    {this.context.translate("_FUEL_ADD_DESC_")}
                  </p>
                </div>
              }
              maskClosable={false}
              onOk={() => this.setState({ openFuelForm: false })}
              onCancel={() =>
                this.setState({ openFuelForm: false, fuelId: "" })
              }
            >
              <div style={{ height: "100%" }}>
                <FuelDetailsAdd
                  fuelId={this.state.fuelId}
                  response={this.responseMsg}
                  closeModal={this.closeModal}
                />
              </div>
            </Drawer>
          )}
        </div>
        {this.state.openDeleteModal && (
          <Modal
            maskClosable={false}
            title={
              <div className="deleteModalTitle">
                <span>
                  {" "}
                  {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
                </span>
                <CloseOutlined
                  style={{ cursor: "pointer", color: "white" }}
                  onClick={() => this.setState({ openDeleteModal: false })}
                />
              </div>
            }
            className="deleteModal"
            description="Are you sure you want to delete this Item? This action cannot be undone."
            centered
            open={this.state.openDeleteModal}
            footer={null}
            width={400}
            closable={false}
          >
            <div className="deleteModalText">
              <p>{this.context.translate("_DELETE_STATUS_")}</p>
            </div>
            <div className="deleteModalButtons">
              <Button
                className="deleteModalCancelButton"
                onClick={() => this.setState({ openDeleteModal: false })}
              >
                {this.context.translate("_FLEET_DASHBORD_SHOWPOI_CANCELBTN_")}
              </Button>

              <Button
                className="deleteModalOkButton"
                onClick={() => this.onDelete(this.state.deleteData)}
              >
                {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
              </Button>
            </div>
          </Modal>
        )}
      </>
    );
  }
}
FuelDetailsList.contextType = StoreContext;
export default observer(withRouter(FuelDetailsList));
